// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAddress --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {Exact} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment StripeAddressFragment on OpenapiAddress {
    city
    country
    line1
    line2
    postal_code
    state
  }
`;

export const stripeAddressFragment: StripeAddressFragmentDocument = doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAddressFragmentData = {
  readonly __typename: 'OpenapiAddress';
  readonly city: string | null;
  readonly country: string | null;
  readonly line1: string | null;
  readonly line2: string | null;
  readonly postal_code: string | null;
  readonly state: string | null;
};

export type StripeAddressFragmentVariables = Exact<{[key: string]: never}>;

const stripeAddressFragmentPermissions = {} as const;

doc.permissions = stripeAddressFragmentPermissions;

export type StripeAddressFragmentPermissions = V1PermissionToken<
  typeof stripeAddressFragmentPermissions
>;

export type StripeAddressFragmentDocument = GraphQlDocument<
  StripeAddressFragmentData,
  StripeAddressFragmentVariables,
  StripeAddressFragmentPermissions
>;
